exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mtag { margin: 48px 0 0px 0;\n}\n.verde { background-color: #DAE8D0; color: #73AD49; font-weight: 700\n}\n.amarillo { background-color: #F5EAD6; color: #D89000; font-weight: 700\n}\n.rojo { background-color: #FBE4DD; color: #C5340B; font-weight: 700\n}\n.azul { background-color: #E6F0FE; color: #2567BF; font-weight: 700\n}\n.tag {\nborder-radius: 8px;\ncursor: default;\ndisplay: inline-block;\nposition: relative;\nwhite-space: nowrap;\nheight: 30px;\npadding: 8px 16px!important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9220ad7a","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/proyectos_show.vue
// module id = 3g4B
// module chunks = 0